import * as React from "react";

import { connect } from "react-redux";
import { calculate_fun } from "../redux/actions/widget";

import {
  Input1,
  ButtonType5,
  InputType2,
  SelectType2,
} from "@visualizeroi/vroi-custom-components";

import { validateForm, saveVisualizer } from "./../helper/common-methods";

type Props2 = {};

const AssumptionView = (props: any) => {
  const { inputs, variables_details, decorate, setAssumption_modal } = props;

  const inputs_values = (code_ref) => {
    return inputs ? decorate(code_ref, inputs[code_ref]).toLocaleString() : "0";
  };

  const getOptions = (code_ref) => {
    console.log(
      variables_details[code_ref] ? variables_details[code_ref].options : {}
    );
    const enum_options = variables_details[code_ref]
      ? variables_details[code_ref].options
      : [];
    let options = {};

    enum_options.map((option) => {
      options[option.name] = option.value;
    });

    return options;
  };

  const handleChange = (e: any, code_ref: any) => {
    props.calculate_fun(
      e,
      code_ref,
      props.visualizer_input_output_values,
      props.calculate
    );
  };

  return (
    <div className="">
      <div className="user_info_header_text">Assumptions </div>

      <InputType2
        title="Months to work an enterprise deal"
        placeholder=""
        value={inputs_values("Months to work a deal low - Number - k42l3")}
        onChange={(e) =>
          handleChange(e, "Months to work a deal low - Number - k42l3")
        }
        className="inputs_var mt24 "
      />

      <InputType2
        title="Months to work a blended deal "
        placeholder=""
        value={inputs_values("Months to work a deal mixed - Number - 1iw70")}
        onChange={(e) =>
          handleChange(e, "Months to work a deal mixed - Number - 1iw70")
        }
        className="inputs_var mt24 "
      />

      <InputType2
        title="Months to work a transactional deal"
        placeholder=""
        value={inputs_values("Months to work a deal high - Number - ptd0v")}
        onChange={(e) =>
          handleChange(e, "Months to work a deal high - Number - ptd0v")
        }
        className="inputs_var mt24 "
      />

      <InputType2
        title="Average expansion in annual contract value"
        placeholder=""
        value={inputs_values(
          "percent of week spent forecasting - Number - k3rs3"
        )}
        onChange={(e) =>
          handleChange(e, "percent of week spent forecasting - Number - k3rs3")
        }
        className="inputs_var mt24 "
      />

      <InputType2
        title="Annual working hours"
        placeholder=""
        value={inputs_values(
          "Number of working hours per year - Number - qxa1y"
        )}
        onChange={(e) =>
          handleChange(e, "Number of working hours per year - Number - qxa1y")
        }
        className="inputs_var mt24 "
      />

      <InputType2
        title="Percent of week spent forecasting"
        placeholder=""
        value={inputs_values(
          "percent of week spent forecasting - Number - k3rs3"
        )}
        onChange={(e) =>
          handleChange(e, "percent of week spent forecasting - Number - k3rs3")
        }
        className="inputs_var mt24 "
      />

      <InputType2
        title="Average percent of pipeline that slips annually"
        placeholder=""
        value={inputs_values(
          "Avg percent of pipeline that slips per year - Number - ik6po"
        )}
        onChange={(e) =>
          handleChange(
            e,
            "Avg percent of pipeline that slips per year - Number - ik6po"
          )
        }
        className="inputs_var mt24 "
      />

      <div className="modal_cta_div mt48">
        <button
          className="Cancel_btn"
          onClick={() => setAssumption_modal(false)}
        >
          Cancel
        </button>
        {/* <button
          onClick={() => setAssumption_modal(false)}
          className="Assumptions-btn"
        >
          Save
        </button> */}

        <ButtonType5
          backgroundColor="#0E7AFF"
          text="Save"
          onClick={() => setAssumption_modal(false)}
          className="download_btn assumptionBtn"
        />
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  const { widget_reducer } = state;
  return {
    ...ownProps,
    visualizer_input_output_values:
      widget_reducer.visualizer_input_output_values,
    inputs: widget_reducer.visualizer_input_output_values
      ? widget_reducer.visualizer_input_output_values.inputs
      : {},
    calculate: widget_reducer.calculate,
    decorate: widget_reducer.decorate,
    variables_details: widget_reducer.visualizer_input_output_details,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    calculate_fun: (
      event,
      code_ref,
      visualizer_input_output_values,
      calculate
    ) =>
      dispatch(
        calculate_fun(
          event,
          code_ref,
          visualizer_input_output_values,
          calculate
        )
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssumptionView);
